// extracted by mini-css-extract-plugin
export default {"listItem":"AdvantageListItem_listItem__zqpQx","listItemContainer":"AdvantageListItem_listItemContainer__UV64I","checkIcon":"AdvantageListItem_checkIcon__gtaUZ"};